import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  fixed: PropTypes.bool,
};

const OnboardingLayoutFooter = ({ className, children, fixed }) => {
  const classes = classNames({
    'onboarding-layout-footer': true,
    'onboarding-layout-footer-fixed': fixed,
    [className]: !!className,
  });

  return (
    <>
      {fixed && <div className="onboarding-layout-footer-spacer" />}
      <div className={classes}>{children}</div>
    </>
  );
};

OnboardingLayoutFooter.propTypes = propTypes;

export default OnboardingLayoutFooter;
